import React from "react";
import axios from "axios";
import * as IoIcons from "react-icons/io";

function DequipoOncologia({ id, onDelete }) {
  const postRemove = async (e) => {
    e.preventDefault();

    try {
      await axios.delete(
        "https://suadesarrollo.azurewebsites.net/api/EliminaEquipoOncologia/" +
          id,
      );

      // ✅ Actualiza el listado sin recargar ni volver a llamar API
      onDelete(id);

      alert("Eliminado con éxito");
    } catch (error) {
      console.error(error);
      alert("Error al eliminar");
    }
  };

  return (
    <button className="btn btn-danger" onClick={postRemove}>
      <IoIcons.IoIosCloseCircleOutline />
    </button>
  );
}

export default DequipoOncologia;
